import React from "react";
import PropTypes from "prop-types";
import SVG from "react-inlinesvg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faTwitter,
  faLinkedin,
  faDribbble,
  faInstagram,
  faYoutube
} from "@fortawesome/free-brands-svg-icons";
import iconGlobe from "../../assets/img/icons/icon-globe.svg";
import { GlobeIcon } from "../../assets/img/icons";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";

class SocialIcons extends React.Component {
  render() {
    const {
      facebook,
      twitter,
      linkedIn,
      website,
      youtube,
      dribbble,
      instagram,
      www,
      trailheadProfileUrl,
      className,
      color
    } = this.props;

    if (
      !website &&
      !facebook &&
      !twitter &&
      !linkedIn &&
      !instagram &&
      !youtube
    ) {
      return null;
    }

    const socialIcons = [];
    if (trailheadProfileUrl) {
      socialIcons.push({
        icon: iconGlobe,
        color: "#292934",
        href: trailheadProfileUrl,
        id: "trailheadprofile"
      });
    }

    if (www) {
      socialIcons.push({
        icon: iconGlobe,
        color: "#292934",
        href: www,
        id: "www"
      });
    }
    if (website) {
      socialIcons.push({
        icon: faGlobe,
        color: "#292934",
        href: website,
        id: "website"
      });
    }
    if (facebook) {
      socialIcons.push({
        icon: faFacebook,
        color: "#292934",
        href: facebook,
        id: "facebook"
      });
    }

    if (twitter) {
      socialIcons.push({
        icon: faTwitter,
        color: "#292934",
        href: twitter,
        id: "twitter"
      });
    }

    if (linkedIn) {
      socialIcons.push({
        icon: faLinkedin,
        color: "#292934",
        href: linkedIn,
        id: "linkedIn"
      });
    }

    if (instagram) {
      socialIcons.push({
        icon: faInstagram,
        color: "#292934",
        href: instagram,
        id: "instagram"
      });
    }

    if (youtube) {
      socialIcons.push({
        icon: faYoutube,
        color: "#292934",
        href: youtube,
        id: "youtube"
      });
    }

    if (dribbble) {
      socialIcons.push({
        icon: faDribbble,
        color: "#292934",
        href: dribbble,
        id: "dribble"
      });
    }

    return (
      <div className={className || ""}>
        {socialIcons.map((socialIcon, key, id) => (
          <div
            id={id}
            key={key}
            className="float-left"
            style={{
              fontSize: 24,
              paddingLeft: 6,
              paddingRight: 6,
              paddingTop: 0,
              paddingBottom: 0
            }}
          >
            <a
              id={id}
              href={socialIcon.href}
              style={{ color: color || socialIcon.color }}
              target="_blank"
              rel="noopener noreferrer"
            >
              {typeof socialIcon.icon === "object" ? (
                <FontAwesomeIcon icon={socialIcon.icon} />
              ) : (
                <SVG src={socialIcon.icon} />
              )}
            </a>
          </div>
        ))}
      </div>
    );
  }
}

SocialIcons.propTypes = {
  className: PropTypes.string,
  facebook: PropTypes.string,
  twitter: PropTypes.string,
  linkedIn: PropTypes.string,
  youtube: PropTypes.string,
  instagram: PropTypes.string
};

export default SocialIcons;
